import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {GameInfo} from "../../../games/game-info";
import {ICompanyViewModel} from "../../../companies/company-view-model.interface";
import {
    IHistoryRecordAmountViewModel, IHistoryRecordIdViewModel,
    IHistoryRecordViewModel
} from "./history-record-view-model.interface";

export abstract class HistoryRecordBaseModel<TRawRecordData> implements IHistoryRecordViewModel {
    constructor(protected  readonly services: IServiceFactoryExtended,
                protected  readonly gameInfo: GameInfo,
                protected readonly company: ICompanyViewModel,
                protected readonly recordData: TRawRecordData) {

    }

    abstract get date(): string;
    abstract get ids(): IHistoryRecordIdViewModel[];
    abstract get bigWinMessage(): string | null;
    abstract get amounts(): IHistoryRecordAmountViewModel[];
    abstract get freePlayMessage(): string | null;
    abstract get detailsHistoryNotAllowedOnCurrentPlatformMessage(): string | null;
    abstract openDetailHistory(): Promise<any>;

    protected abstract _isDetailHistorySupported(): boolean;

    get gameName(): string {
        return this.gameInfo.title;
    }

    get gameImage(): string {
        return this.gameInfo.gameImageInHistoryPage;
    }

    get getGameImagePlaceHolderUrl(): string {
        return this.gameInfo.getGameImagePlaceHolderUrl(false);
    }

    protected _formatValue(value: number): string {
        return this.services.currency.formatMoney(value);
    }

    protected get translation() {
        return this.services.translation;
    }

    get supportsDetailHistory(): boolean {
        return this._isDetailHistorySupported();
    }

    get canPlayGame(): boolean {
        return Boolean(this.services.games.gamesMap[this.gameInfo.gameType]);
    }

    async playGame(): Promise<void> {
        if(!this.canPlayGame) {
            return;
        }
        await this.gameInfo.open({
            isRealMode: true,
            showIntermediatePage: false,
        });

        this.services.analytics.sendAnalytics('Client_GamingHistory', 'open_game', this.gameInfo.title, this.gameInfo.gameType);

    }
}